import { Link, useNavigate } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  author: string;
  avatar: string;
  publishDate: string;
  readCount: string;
  isHot?: boolean;
  isExclusive?: boolean;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  category,
  categorySlug,
  imageUrl,
  author,
  avatar,
  publishDate,
  readCount,
  isHot,
  isExclusive,
}: ArticleCardProps) {
  const navigate = useNavigate();

  const handleCategoryClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(`/category/${categorySlug}`);
  };

  return (
    <article className="bg-background-50 rounded-xl overflow-hidden hover:bg-background-100 transition-colors duration-200 group">
      <Link to={`/article/${slug}`} className="block">
        <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
          <img
            src={imageUrl}
            alt={title}
            title={`${title} - 黑料吃瓜网`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
          <div className="absolute top-3 left-3 flex gap-1.5 flex-wrap">
            {isHot && (
              <span className="px-2 py-0.5 text-xs font-semibold rounded-full bg-primary-500 text-background-50 whitespace-nowrap">
                热
              </span>
            )}
            {isExclusive && (
              <span className="px-2 py-0.5 text-xs font-semibold rounded-full bg-accent-500 text-background-50 whitespace-nowrap">
                独家
              </span>
            )}
          </div>
        </div>
        <div className="p-4">
          <button
            type="button"
            onClick={handleCategoryClick}
            className="inline-block px-2 py-0.5 text-xs font-medium rounded-full bg-secondary-100 text-secondary-800 mb-2 hover:bg-secondary-200 transition-colors cursor-pointer whitespace-nowrap"
          >
            {category}
          </button>
          <h3 className="text-base font-bold font-heading text-foreground-950 leading-snug mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {title}
          </h3>
          <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
            {excerpt}
          </p>
          <div className="flex items-center justify-between text-xs text-foreground-500">
            <div className="flex items-center gap-2">
              <img
                src={avatar}
                alt={author}
                className="w-5 h-5 rounded-full object-cover"
              />
              <span>{author}</span>
            </div>
            <div className="flex items-center gap-3">
              <span>{publishDate}</span>
              <span className="flex items-center gap-1">
                <i className="ri-eye-line"></i>
                {readCount}
              </span>
            </div>
          </div>
        </div>
      </Link>
    </article>
  );
}